import { render, staticRenderFns } from "./PartslisteditlinePage.vue?vue&type=template&id=2090ffec"
import script from "./PartslisteditlinePage.vue?vue&type=script&lang=js"
export * from "./PartslisteditlinePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports